import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { environment } from '../../../environments/environment';
import { NotificationInAppDto } from '../../common/general-types/notifications.dto';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsInAppService {

  /** Subject to follow to keep unread count live */
  $unreadNotificationCount: Subject<number> = new Subject();

  unreadNotifications = signal<NotificationInAppDto[]>([]);

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  // listenToNotifications(businessUserId: string) {
  //   this.updateUnreadCount(businessUserId);
  //   this.subscribeToReadNotifications();
  //   const q = query(
  //     collection(this.db, 'create-ia-notifications'),
  //     where('businessUserId', '==', businessUserId)
  //   );
  //   const unsubscribe = onSnapshot(q, (querySnapshot) => {
  //     querySnapshot.forEach((doc) => {
  //       let incoming = JSON.parse(JSON.stringify(doc.data()));
  //       if (!incoming.read) {
  //         this.incomingNotifications.push(<NotificationInAppDto>doc.data());
  //       }
  //       this.FBnotifications.push(<NotificationInAppDto>doc.data());
  //     });
  //   });
  // }

  subscribeToReadNotifications() {
    this.$unreadNotificationCount.next(0);
    this.$unreadNotificationCount.subscribe(() => {
      if (this.firebaseService.userId) {
        this.getUserUnreadNotifications(
          this.firebaseService.userId
        ).subscribe((unreadRes) => {
          this.unreadNotifications.set(unreadRes);
        });
      }
    });
  }

  updateUnreadCount(businessUserId: string) {
    this.getUserUnreadNotifications(businessUserId).subscribe(
      (unreadNotifications) => {
        this.$unreadNotificationCount.next(unreadNotifications.length);
      }
    );
  }

  getUserUnreadNotifications(userId: string) {
    const unread_notifications_url = `${environment.shout_api.url}/notification-in-app/all-user-unread/${userId}`;
    return this.http.get<NotificationInAppDto[]>(unread_notifications_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getUserNotifications(userId: string) {
    const get_user_notifications_url = `${environment.shout_api.url}/notification-in-app/all-user/${userId}`;
    return this.http.get<NotificationInAppDto[]>(get_user_notifications_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  markAllAsRead(userId: string) {
    const mark_all_as_read_url = `${environment.shout_api.url}/notification-in-app/mark-read-all/${userId}`;
    return this.http.post(mark_all_as_read_url, {}, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  }

  markAsRead(notificationId: string) {
    const mark_all_as_read_url = `${environment.shout_api.url}/notification-in-app/mark-read/${notificationId}`;
    return this.http.get(mark_all_as_read_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  }
}
